import React, { useEffect, useState } from 'react';

import { isEmpty } from 'lodash';

import { uploadEmployeeCSVStatus } from 'services/admin';

import { BulkUploadCard } from './BulkUploadCard';

const POLL_INTERVAL = 3000;

const wait = (ms = 1000) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

const bulkUploadStatus = (uploadType = 'EMP_BULK_UPLOAD') => uploadEmployeeCSVStatus({ uploadType });

const BulkUploadStatus = ({
  setUploading = () => false,
  reload,
  uploadType = 'EMP_BULK_UPLOAD',
  getUploadStatus = () => {},
  renderUI = null,
}) => {
  const [status, setStatus] = useState({});

  useEffect(() => {
    getUploadStatus(status);
  }, [getUploadStatus, status]);

  const apiPoll = async (fetchFunction, functionCondition, pollingInterval) => {
    try {
      let result = await fetchFunction();
      setStatus(result);
      while (functionCondition(result)) {
        await wait(pollingInterval);
        result = await fetchFunction();
        setStatus(result);
      }
      setStatus(result);
    } catch (err) {
      console.error('Error in fetching status of CSV ', err);
      setStatus({ status: 'ERROR' });
    }
  };

  const validateStatusResponse = (res) => {
    switch (res?.status) {
      case 'IN_PROGRESS':
        setUploading(true);
        return true;
      case 'VALIDATING':
        setUploading(true);
        return true;
      case 'FINISHED':
        setUploading(false);
        return false;
      case 'ERROR': {
        setUploading(false);
        // onError('Error in generating file');
        return false;
      }
      default:
        setUploading(false);
        // onError('Error in generating file');

        return false;
    }
  };

  useEffect(() => {
    apiPoll(() => bulkUploadStatus(uploadType), validateStatusResponse, POLL_INTERVAL);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  if (isEmpty(status)) {
    return null;
  }

  if (typeof renderUI === 'function') {
    return renderUI(status);
  }

  return (
    <BulkUploadCard
      recordsUpdated={status?.recordsUpdated}
      totalRecords={status?.totalRecords}
      type={status?.status}
      fileName={status?.fileName}
      uuid={status?.uuid}
    />
  );
};

export { BulkUploadStatus };
